import { FC, useState, useRef, useEffect } from 'react';
import { Paper, TextField, IconButton } from '@mui/material';
import NearMeIcon from '@mui/icons-material/NearMe';
import { useChat } from '@carcareers/contexts';

export const SendMessage: FC = () => {
  const { selectedRoom, sendMessage, sending } = useChat();

  const [messageText, setMessageText] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSendMessage = async () => {
    if (!messageText.trim() || !selectedRoom) return;

    try {
      await sendMessage(messageText);
      setMessageText('');

      // Return focus to the text input after sending the message
      inputRef.current?.focus();
    } catch (error) {
      console.error('Error sending message:', error);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [selectedRoom]);

  return (
    <Paper
      elevation={3}
      sx={{
        p: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        width: '100%',
        borderRadius: 0,
      }}
    >
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Type your message..."
        value={messageText}
        onChange={(e) => setMessageText(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={sending}
        inputRef={inputRef}
        multiline
        maxRows={5}
        slotProps={{
          input: {
            sx: {
              borderRadius: 4,
            },
          },
        }}
        sx={{
          '& .MuiInputBase-root': {
            overflow: 'auto',
          },
        }}
      />
      <IconButton
        onClick={handleSendMessage}
        disabled={!messageText.trim() || sending}
        sx={{
          height: '56px',
          width: '56px',
          flexShrink: 0,
          borderRadius: 4,
          backgroundColor: 'primary.main',
          color: 'white',
          '&.Mui-disabled': {
            backgroundColor: 'grey.300',
          },
        }}
      >
        <NearMeIcon />
      </IconButton>
    </Paper>
  );
};

export default SendMessage;
